<template>
  <div :v-if="list.length" class="cataloguePavilion">
    <div class="pavilion" v-for="(item,i) in list" :key="i">
      <div class="pavilionImg">
        <el-image 
          :lazy="true"
          fit="cover"
          :src="item.minurl" 
          :preview-src-list="[item.maxurl]">
        </el-image>
      </div>
      <div class="cataContent">
        <div class="pavilionTitle">
          <div>{{item.code}}</div>
          <div>
            <h2>{{item.title_cn}}</h2>
            <p><a :href="item.maxurl" target="_block">点击查看</a></p>
          </div>
        </div>
        <p v-for="(conItem,i) in item.contentArr_cn" :key="i">{{conItem}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      list:[
        {
          title_cn:"东1号馆",
          title_en:"东1号馆",
          code:"E1",
          minurl:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/e1.jpg",
          maxurl:"http://public.cippe.com.cn/static/hall/2026bj/hall_e1.jpg",
          contentArr_cn:["中石油展团","石油勘探","钻采设备"],
          contentArr_en:["中石油展团","石油勘探","钻采设备"]
        },
        {
          title_cn:"东2号馆",
          title_en:"东2号馆",
          code:"E2",
          minurl:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/e2.jpg",
          maxurl:"http://public.cippe.com.cn/static/hall/2026bj/hall_e2.jpg",
          contentArr_cn:["中石化展团","石油勘探","钻采设备"],
          contentArr_en:["中石化展团","石油勘探","钻采设备"]
        },
        {
          title_cn:"东3号馆",
          title_en:"东3号馆",
          code:"E3",
          minurl:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/e3.jpg",
          maxurl:"http://public.cippe.com.cn/static/hall/2026bj/hall_e3.jpg",
          contentArr_cn:["石油装备","页岩气","流体机械","仪表及电气"],
          contentArr_en:["石油装备","页岩气","流体机械","仪表及电气"]
        },
        {
          title_cn:"东4号馆",
          title_en:"东4号馆",
          code:"E4",
          minurl:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/e4.jpg",
          maxurl:"http://public.cippe.com.cn/static/hall/2026bj/hall_e4.jpg",
          contentArr_cn:["天然气","燃气","防爆","安全防护"],
          contentArr_en:["天然气","燃气","防爆","安全防护"],
        },
        {
          title_cn:"西1号馆",
          title_en:"西1号馆",
          code:"W1",
          minurl:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/w1.jpg",
          maxurl:"http://public.cippe.com.cn/static/hall/2026bj/hall_w1.jpg",
          contentArr_cn:["国际展团","海洋石油"],
          contentArr_en:["国际展团","海洋石油"],
        },
        {
          title_cn:"西2号馆",
          title_en:"西2号馆",
          code:"W2",
          minurl:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/w2.jpg",
          maxurl:"http://public.cippe.com.cn/static/hall/2026bj/hall_w2.jpg",
          contentArr_cn:["国际展区","海洋工程"],
          contentArr_en:["国际展区","海洋工程"],
        },
        {
          title_cn:"西3号馆",
          title_en:"西3号馆",
          code:"W3",
          minurl:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/w3.jpg",
          maxurl:"http://public.cippe.com.cn/static/hall/2026bj/hall_w3.jpg",
          contentArr_cn:["管道","流体机械","仪器仪表"],
          contentArr_en:["管道","流体机械","仪器仪表"],
        },
        {
          title_cn:"西4号馆",
          title_en:"西4号馆",
          code:"W4",
          minurl:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/w4.jpg",
          maxurl:"http://public.cippe.com.cn/static/hall/2026bj/hall_w4.jpg",
          contentArr_cn:["H2氢能装备/制","储、运、加、用"],
          contentArr_en:["H2氢能装备/制","储、运、加、用"],
        }
      ]
    }
  }
}
</script>
<style scoped>  
  .pavilion{
    width: 100%;
    height: 250px;
    background: white;
    margin-bottom: 11px;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
  }
  .pavilionImg{
    width: 48%;
    height: 100%;
    border: 2px solid #eff0f0;
    overflow: hidden;
  }
  .pavilionImg>div{
    width: 100%;
    height: 100%;
  }
  .pavilionImg>>>.el-image-viewer__mask{
    opacity: .8;
  }
  .pavilionImg>>>.el-image-viewer__close{
    color: white;
  }
  .cataloguePavilion>>>.el-image-viewer__canvas{
    padding: 20px;
  }
  .cataContent{
    width: calc(100% - 100px);
  }
  .cataContent >p{
    padding: 0 20px;
    padding-top: 6px;
    font-size: 12px;
    font-weight: 600;
  }
  .pavilionTitle{
    margin-top:22px;
    display: flex;
    justify-content: center;
  }
  .pavilionTitle>div:first-child{
    height: 48px;
    vertical-align: middle;
    font-size: 38px;
    padding-right: 6px;
    border-right: 1px solid #008baf;
    color: #008baf;
  }
  .pavilionTitle>div:last-child{
    padding-left: 12px;
  }
  .pavilionTitle>div>h2{
    color: #333;
    font-size: 19px;
    line-height: 28px;
  }
  .pavilionTitle>div a{
    font-size: 12px;
    color: #008baf;
    font-weight: 900;
    line-height: 20px;
  }
</style>